import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import ProductItem from '../../components/festival/ProductItem'

import { isMobile } from 'react-device-detect'
import ProductHeader from '../../components/festival/ProductHeader'
import ProductListItem from '../../components/festival/ProductListItem'
import ProductSortModal from '../../components/festival/ProductSortModal'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductFilterCenterModal from '../../components/product/ProductFilterCenterModal'
import ProductFilterModal from '../../components/product/ProductFilterModal'
import ProductModal from '../../components/product/ProductModal'
import '../../css/Product.css'

import { SectionDetailProduct } from '../../@types/home'
import { getSectionsDetailKeywordVer1, getSectionsDetailKeyword, getSectionsDetailSale } from '../../api/home'
import { getFestivals } from '../../api/login'
import { imgURL } from '../Home'
import CategoryManyProduct from './CategoryManyProduct'
import { useAppContext } from '../../components/provider/AppProvider'

// 이미지 경로

export default function FestivalSection() {
  const [twoDepCategory, setTwodepCategory] = useState<any>([])
  const [isModal, setIsModal] = useState(false)
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [type, setType] = useState<string>('thumb')
  const [sortKeyword, setSortKeyword] = useState<string>('RECOMMENDATION') //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('추천순') //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC') //정렬 내림차순?오름차순
  const [isSort, setIsSort] = useState(false) //정렬 팝업열기
  const [isFilter, setIsFilter] = useState(false) //필터 팝업열기
  const [getMax, setGetMax] = useState<any>(1000000)
  const [getMin, setGetMin] = useState<any>(0)
  const [freeCheck, setFreeCheck] = useState(false)
  const [filterApply, setFilterApply] = useState(false)
  const [brandArray, setBrandArray] = useState<any>([])
  const [filterTotal, setFilterTotal] = useState(0)
  const [filterMin, setFilterMin] = useState(0)
  const [filterMax, setFilterMax] = useState(1000000)
  const [one, setOne] = useState<any>()
  const [max, setMax] = useState(1000000)
  const [min, setMin] = useState(0)
  const [thirdDepLabel, setThirdDepLabel] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [allsection, setAllsection] = useState<any>([]) //대량모듈 섹션 정보
  const [sectionDetail, setSectionDetail] = useState<any>([]) //카테고리 섹션 정렬안된거
  const [sectionDetails, setSectionDetails] = useState<SectionDetailProduct[]>([]) //카테고리섹션 정렬
  const [categorySectionNo, setCategorySectionNo] = useState<any>() //선택된 카테고리 번호
  const [categoryLike, setCategoryLike] = useState<boolean>(false) // 카테고리 좋아요
  const [categoryItem, setCategoryItem] = useState<any>([])
  const [sectionCategory, setSectionCategory] = useState<any>([]) //섹션 카테고리 안변하게
  const [sortSectionCategory, setSortSectionCategory] = useState<any>([]) //섹션 카테고리 정렬
  const location = useLocation()

  const obsRef = useRef(null) //observer Element
  const itemRef = useRef(null)
  const preventRef = useRef(true) //옵저버 중복 실행 방지
  const endRef = useRef(false) //모든 글 로드 확인

  const [page, setPage] = useState(1) //현재 페이지
  const [festivalData, setFestivalData] = useState<any>([])
  const [selectData, setSelectData] = useState<any>([])
  const [sectionNo, setSectionNo] = useState<number>(0) //선택된 카테고리 번호
  const [mobileImage, setMobileImage] = useState<string>('') //모바일 이미지
  const [pcImage, setPcImage] = useState<string>('') //PC 이미지
  const [productTotalCount, setProductTotalCount] = useState(0) //총 상품 수
  const listItemRef = useRef<any>(null)

  const { isAppView } = useAppContext()

  useEffect(() => {
    let locationPath = location?.state?.path
    let locationSectionNo = Number(location?.state?.sectionNo)
    let locationMobileImage = location?.state?.mobileImage
    let locationPcImage = location?.state?.pcImage

    if (isAppView) {
      const searchParams = new URLSearchParams(location.search)
      locationPath = searchParams.get('path') // path 값 추출
      locationSectionNo = Number(searchParams.get('sectionNo')) // sectionNo 값 추출
      locationMobileImage = searchParams.get('mobileImage') // mobileImage 값 추출
      locationPcImage = searchParams.get('pcImage') // pcImage 값 추출
    }

    setSectionNo(locationSectionNo)
    setMobileImage(locationMobileImage)
    setPcImage(locationPcImage)

    if (locationPath) {
      getFestivals(locationPath).then((res) => {
        setFestivalData(res.data.festival.shopbyFestivalComponents)
        setCategorySectionNo(locationSectionNo)
      })
    } else {
      setCategorySectionNo(locationSectionNo)
    }
  }, [])

  useEffect(() => {
    if (festivalData) {
      const foundData = festivalData.find((el: any) => el.type === 'horizontal-scroll')
      if (foundData) {
        setSelectData(foundData)
      }
    }
  }, [festivalData])

  const obsHandler = (entries: any) => {
    //옵저버 콜백함수
    const target = entries[0]
    if (!endRef.current && target.isIntersecting && preventRef.current) {
      //옵저버 중복 실행 방지
      preventRef.current = false //옵저버 중복 실행 방지
      setPage((prev) => prev + 1) //페이지 값 증가
    }
  }

  useEffect(() => {
    //옵저버 생성
    if (sectionDetails) {
      const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 })
      if (obsRef.current) observer.observe(obsRef.current)
      return () => {
        observer.disconnect()
      }
    }
  }, [sectionDetails, itemRef])

  //상품진열관리 상세 조회
  useEffect(() => {
    if (categorySectionNo && sortKeyword) {
      if (sectionNo) {
        getSectionsDetailKeywordVer1(Number(sectionNo), sortKeyword, page).then((res) => {
          if (page === 1) setProductTotalCount(res.data.productTotalCount)
          setSectionDetails((prev) => [...prev, ...res.data.products])
        })
      } else {
        getSectionsDetailKeyword(Number(sectionNo), sortKeyword).then((res) => {
          setSectionDetails(res.data.products)
        })
      }
    }
  }, [categorySectionNo, categoryLike, sortKeyword, page])

  //카테고리용 상세조회

  useEffect(() => {
    if (allsection) {
      const fetchSectionsDetails = async () => {
        try {
          const responses = await Promise.all(allsection.map((el: any) => getSectionsDetailSale(el.sectionNo)))

          const allData = responses.flatMap((res) => res.data)
          setSectionCategory(allData)
        } catch (error) {
          console.error('Error fetching sections details:', error)
        }
      }

      fetchSectionsDetails()
    }
  }, [allsection])

  //카테고리 소팅
  useEffect(() => {
    if (sectionCategory) {
      const sorting = sectionCategory.sort((a: any, b: any) => {
        return a.sectionNo - b.sectionNo
      })
      setSortSectionCategory(sorting)
    }
  }, [sectionCategory])

  useEffect(() => {
    setTimeout(() => {
      setLoading(true)
    }, 300)
  }, [])

  useEffect(() => {
    if (sectionDetail && categorySectionNo && loading) {
      const foundItem = sectionDetail.find((el: any) => Number(el.sectionNo) === Number(categorySectionNo))

      if (foundItem) {
        setCategoryItem(foundItem.products)
      }
    }
  }, [sectionDetail, categorySectionNo, loading])

  return (
    <>
      <div className='main_wrap'>
        {selectData.length !== 0 && (mobileImage || pcImage) && (
          <img src={isMobile ? mobileImage : pcImage} alt='' className=' product' />
        )}
        {/* 카테고리 */}
        <CategoryManyProduct />

        {/* 카테고리 4dept */}

        {/* 상품 목록 전체 wrap */}
        <div className={'product_list_wrap product'}>
          {/* 상품목록 header */}
          <ProductHeader
            totalCount={productTotalCount}
            type={type}
            setSortDirection={setSortDirection}
            sortDirection={sortDirection}
            setSortKeywordLabel={setSortKeywordLabel}
            setType={setType}
            isSort={isSort}
            setIsSort={setIsSort}
            sortKeyword={sortKeyword}
            setSortKeyword={setSortKeyword}
            sortKeywordLabel={sortKeywordLabel}
            setIsFilter={setIsFilter}
            filterTotal={filterTotal}
          ></ProductHeader>

          {/* 상품 Item Wrap */}

          {sectionDetails.length !== 0 && loading ? (
            <>
              <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'} ref={listItemRef}>
                {type === 'thumb' &&
                  sectionDetails.map((el: any, idx: number) => {
                    return (
                      <ProductItem
                        item={el}
                        key={el.productNo}
                        setIsModal={setIsModal}
                        setSelectProductNo={setSelectProductNo}
                        page={page}
                        one={one}
                        twoDepCategory={twoDepCategory}
                        thirdDepLabel={thirdDepLabel}
                        idx={idx}
                      />
                    )
                  })}
                {type === 'list' &&
                  sectionDetails.map((el: any, idx: number) => {
                    return (
                      <ProductListItem
                        item={el}
                        idx={idx}
                        key={el.productNo}
                        setIsModal={setIsModal}
                        setSelectProductNo={setSelectProductNo}
                        page={page}
                        one={one}
                        twoDepCategory={twoDepCategory}
                        thirdDepLabel={thirdDepLabel}
                      />
                    )
                  })}
              </div>
            </>
          ) : (
            <div className='product_list_wrap empty'>
              <div className='no_data'>
                <img src={`${imgURL}/empty_logo.png`} alt='' />
                <p>상품이 없습니다.</p>
              </div>
            </div>
          )}
        </div>
        {isMobile && isSort ? (
          <ProductSortModal
            headerText='정렬'
            setIsModal={setIsSort}
            setSortKeyword={setSortKeyword}
            sortKeyword={sortKeyword}
            setSortKeywordLabel={setSortKeywordLabel}
            setSortDirection={setSortDirection}
            sortDirection={sortDirection}
          ></ProductSortModal>
        ) : null}
        {isModal ? (
          isMobile ? (
            <ProductModal
              setIsModal={setIsModal}
              listItem={sectionDetails}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
            ></ProductModal>
          ) : (
            <ProductCenterModal
              setIsModal={setIsModal}
              headerText={'옵션선택'}
              selectProductNo={selectProductNo}
              listItem={sectionDetails}
            ></ProductCenterModal>
          )
        ) : null}
        {isFilter ? (
          isMobile ? (
            <ProductFilterModal
              isCategoryModal={isFilter}
              setIsCategoryModal={setIsFilter}
              setFreeCheck={setFreeCheck}
              setGetMax={setGetMax}
              setGetMin={setGetMin}
              setFilterApply={setFilterApply}
              setBrandArray={setBrandArray}
              brandArray={brandArray}
              freeCheck={freeCheck}
              max={max}
              filterMax={filterMax}
              setMax={setMax}
              min={min}
              filterMin={filterMin}
              setMin={setMin}
            ></ProductFilterModal>
          ) : (
            <ProductFilterCenterModal
              isCategoryModal={isFilter}
              setIsCategoryModal={setIsFilter}
              setFreeCheck={setFreeCheck}
              setGetMax={setGetMax}
              setGetMin={setGetMin}
              setFilterApply={setFilterApply}
              setBrandArray={setBrandArray}
              brandArray={brandArray}
              freeCheck={freeCheck}
              max={max}
              filterMax={filterMax}
              setMax={setMax}
              min={min}
              filterMin={filterMin}
              setMin={setMin}
            ></ProductFilterCenterModal>
          )
        ) : null}
      </div>
      <div ref={obsRef}></div>
      {/* <div ref={obsRef} style={{ height: "20px" }}></div> */}
    </>
  )
}
// 상품목록 헤더영역 wrap
export const ProductListHeder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
  @media screen and (min-width: 768px) {
    padding: 14px 0;
  }
`

export const ProductListNum = styled.div`
  color: var(--colGray6);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  & span {
    color: var(--colBlack);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
`

// 상품목록 헤더옵션(정렬, 필터, 상품목록 보기정렬 버튼)
export const ProductListOption = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & li {
    position: relative;
    & img {
    }
    @media screen and (min-width: 768px) {
      &:first-of-type {
      }
      &:nth-of-type(2) {
      }
      &:last-of-type {
      }
    }
    & .sort_layer {
      @media screen and (min-width: 768px) {
        position: absolute;
        top: 32px;
        right: 0;
        min-width: 135px;
        border-radius: 8px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
        background: var(--colWhite);
        z-index: 10;
        & ul {
          padding: 6px 32px 6px 16px;
          & li > a {
            display: block;
            font-size: 16px;
            font-weight: 500;
            line-height: 20px;
            color: var(--colGray5);
            padding: 10px 0;
          }
          & li.on a {
            color: var(--colBlack);
            font-weight: 600;
          }
        }
      }
    }
  }
  & > li::after {
    content: '';
    position: absolute;
    top: calc(50% - (14px / 2));
    right: 0;
    width: 1px;
    height: 14px;
    background: var(--colGray3);
  }
  & > li:last-child {
    padding-left: 12px;
  }
  & > li:last-child::after {
    display: none;
  }
`

// 상품목록 영역 wrap
export const ProductWrap = styled.div<{ listType: string }>`
  font-size: 14px;
  display: grid;
  grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)')};
  grid-gap: ${(props) => (props.listType === 'thumb' ? '30px 12px' : '16px')};

  @media screen and (min-width: 768px) {
    grid-template-columns: ${(props) => (props.listType === 'thumb' ? 'repeat(4, 1fr)' : 'repeat(1, 1fr)')};
    grid-gap: 48px 16px;
    margin-bottom: 84px;
  }
`
